import deleteFetcher from 'api/utils/deleteFetcher';
import { useCallback } from 'react';
import type { DeleteTagReturn } from 'types/legacyDashboard';

interface UseDeleteTagProps {
  tagId?: TagId;
  orgId?: OrgId;
}

const useDeleteTagCall = ({ tagId, orgId }: UseDeleteTagProps) => {
  const queryParams = new URLSearchParams({ orgid: `${orgId}` });
  const url = `${process.env.VITE_API_ROOT}/devices/tags/${tagId}?${queryParams}`;

  const callback = useCallback(async () => {
    if (!tagId || !orgId) {
      return undefined;
    }
    const result: DeleteTagReturn | undefined = await deleteFetcher({
      url,
      body: null,
    });

    return result;
  }, [orgId, tagId, url]);

  return callback;
};

export default useDeleteTagCall;
